import { CLAIM_COUNT_QUESTION_ID } from '../../constants/domain-specific';
import { ClaimCount } from '../../slices/extraInfo';
import { Question } from '../../types/policy';
import { EnhancedExtraInfo } from '../index';

export const getQuestions = ({
  extraInfo: { historyQuestions, claimCount },
}: {
  extraInfo: EnhancedExtraInfo;
}): Question[] => {
  /**
   * Business Decision - we only need to create questions from 2 - N
   * as only the answer to the first question is being changed currently
   */
  const remainingQuestions = historyQuestions
    ? [...Array(historyQuestions.length + 1).keys()].slice(2).map((key) => ({
        questionId: String(key),
        answer: { text: 'false' },
      }))
    : [];
  return [
    {
      questionId: CLAIM_COUNT_QUESTION_ID,
      answer:
        claimCount === ClaimCount.One
          ? {
              text: 'true',
              value: '1',
            }
          : { text: 'false' },
    },
    ...remainingQuestions,
  ];
};
